import { render, staticRenderFns } from "./IpoBrokerAccounts.vue?vue&type=template&id=669c8722&scoped=true"
import script from "./IpoBrokerAccounts.vue?vue&type=script&lang=js"
export * from "./IpoBrokerAccounts.vue?vue&type=script&lang=js"
import style0 from "./IpoBrokerAccounts.vue?vue&type=style&index=0&id=669c8722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c8722",
  null
  
)

export default component.exports